import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import asset from "json/assets";
import { Typography } from "@mui/material";

export default function BackdropLoader({ open = false, text = "" }) {
  // for progress loader
  // const [progress, setProgress] = React.useState(0);
  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
  //   }, 800);

  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);
  //end progress loader

  return (
    <div>
      <Backdrop
        // sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}

        open={open}
        // onClick={handleClose}
      >
        {/* <img src={asset.logo} alt="" style={{width:"220px", paddingRight:"30px"}} /> */}
        <CircularProgress color="inherit" />
        <Typography sx={{ margin: "2px 10px" }}>{text}</Typography>
        {/* <CircularProgress /> */}
        {/* <CircularProgress variant="determinate" value={progress} /> */}
      </Backdrop>
    </div>
  );
}
